<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import { mloc } from "module/utils";
  import {
    cloneFilterConfig,
    type SearchFilterConfig,
  } from "module/store/Filters";

  import FilterSectionTypes from "./FilterSectionTypes.svelte";
  import FilterSectionLocation from "./FilterSectionLocation.svelte";

  import FilterModalFolders from "./FilterModalFolders.svelte";
  import FilterModalPacks from "./FilterModalPacks.svelte";
  import FilterModalSubTypes from "./FilterModalSubTypes.svelte";
  import NiceButton from "../NiceButton.svelte";

  let {
    filterConfig,
    title,
    disabled = false,
  }: {
    filterConfig: SearchFilterConfig;
    title?: string;
    disabled?: boolean;
  } = $props();

  let modalOpen: "folders" | "packs" | "actors" | "items" | undefined =
    $state();

  const dispatch = createEventDispatcher();

  const updateFilter = (changes: Partial<SearchFilterConfig>) => {
    if (!filterConfig) return;

    const newConfig: SearchFilterConfig = cloneFilterConfig(filterConfig);

    Object.assign(newConfig, changes);

    dispatch("change", newConfig);
  };

  function closeModal() {
    modalOpen = undefined;
  }

  function openModal(event: CustomEvent<typeof modalOpen>) {
    modalOpen = event.detail;
  }

  function clearFilter() {
    dispatch("change", {
      compendiums: [],
      folders: [],
      documentTypes: [],
    });
  }
</script>

<section class="qi-filter-editor">
  <main>
    {#if title}
      <h2>{title}</h2>
    {/if}
    <FilterSectionTypes
      config={filterConfig}
      on:openModal={openModal}
      on:change={(event) => updateFilter(event.detail)}
      {disabled}
    />
    <FilterSectionLocation
      config={filterConfig}
      on:openModal={openModal}
      on:change={(event) => updateFilter(event.detail)}
      {disabled}
    />
    <footer>
      <span></span>
      <!-- <NiceButton>Save</NiceButton> -->
      <NiceButton on:click={clearFilter}
        >{mloc("FilterEditorResetFilter")}</NiceButton
      >
    </footer>
  </main>

  <FilterModalSubTypes
    thisType="Actor"
    config={filterConfig}
    open={modalOpen === "actors"}
    on:close={closeModal}
    on:change={(event) => updateFilter(event.detail)}
  />

  <FilterModalSubTypes
    thisType="Item"
    config={filterConfig}
    open={modalOpen === "items"}
    on:close={closeModal}
    on:change={(event) => updateFilter(event.detail)}
  />

  <FilterModalFolders
    config={filterConfig}
    open={modalOpen === "folders"}
    on:close={closeModal}
    on:change={(event) => updateFilter(event.detail)}
  />

  <FilterModalPacks
    config={filterConfig}
    open={modalOpen === "packs"}
    on:close={closeModal}
    on:change={(event) => updateFilter(event.detail)}
  />
</section>

<style>
  :root {
    display: flex;
    flex-direction: row;
  }

  section {
    position: relative;
    height: 100%;
    width: 100%;
    background: var(--qiFilterAccent);
    border-radius: 6px;
    color: var(--color-light-2);
    overflow: hidden;
    --color-text-primary: var(--color-light-2);
  }

  section :global(h3) {
    font-size: 120%;
    margin: 6px 0 !important;
    color: var(--color-light-2);
    text-shadow: none;
  }

  h3 {
    padding: 0 1em 0.2em;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }

  main {
    width: 100%;
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  footer {
    display: flex;
    flex-grow: 1;
    align-items: end;
  }
  /** Format like the button */
  span {
    height: 30px;
    line-height: 28px;
    width: 100%;
    margin: 6px;
    padding: 1px 4px;
    opacity: 0.6;
    text-align: center;
  }
</style>
